import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Dialog, DialogContent, DialogActions, DialogTitle, Link } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { getLocalStorageInfo } from '../../../utils';
import config from '../../../config';
const LicenseFailModal = ({history, match, licenseDesc, licenseModal, toggleModalFn}) => {
  return(
    <Dialog
      open={licenseModal}
      aria-labelledby="scroll-dialog-title"
      onClose={toggleModalFn}
      classes={{paperScrollPaper: "license-modal"}}
      maxWidth="lg"
    >
      <DialogContent dividers={true}>
        <div className="licence-description">
          <p align="center" style={{marginBottom:'20px', marginTop:'20px'}}>{licenseDesc}</p>
          <p align="center" style={{marginBottom:'20px'}}>Please contact
            <a href="mailto:sales@acumen.aero" target="_blank"> sales@acumen.aero</a> /
            <a href="mailto:support@sparta.aero" target="_blank"> support@sparta.aero</a>
          </p>
        </div>
        <div align="center" style={{marginBottom:'20px'}}>
        <Button color="primary" variant="contained" onClick={toggleModalFn}>OKAY</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default withRouter(LicenseFailModal);
